import { render, staticRenderFns } from "./Sorry.vue?vue&type=template&id=6fc41b5f&scoped=true&"
import script from "./Sorry.vue?vue&type=script&lang=js&"
export * from "./Sorry.vue?vue&type=script&lang=js&"
import style0 from "./Sorry.vue?vue&type=style&index=0&id=6fc41b5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc41b5f",
  null
  
)

export default component.exports